import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SortBot } from '../../../../app/helpers/sort';
import { SortItem } from '../../../../app/models/ss-api/responses/member.dashboard.license.response';

class OrphanArray extends Array<any> {
    public LastSort = new SortItem()
}

@Component({
    selector: 'member-orphans',
    templateUrl: './member.orphans.component.html',
    styleUrls: ['./member.orphans.component.css']
})

export class MemberOrphanComponent implements OnInit, OnDestroy {
    IsBusy: boolean = false;

    OrphanSearch: string;

    orphanResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    @Input('Orphans') Orphans: OrphanArray;

    constructor(private router: Router) { }

    ngOnInit() {

    }

    ngOnDestroy() {

    }

    SortBy(sortVar1: string, sortVar2: string = '') {
        this.Orphans = SortBot.SortAuto(this.Orphans, sortVar1, sortVar2);
    }

    onMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    paginateOrphans(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

}
